import { DriverDocument } from '../../services/driverApi';

export function avrNumber(doc: DriverDocument) {
  const meta = doc.metadata as Record<string, unknown> | undefined;
  return (meta?.document_number as string) || doc.yandexId || '';
}

export function docTitle(doc: DriverDocument) {
  const number = avrNumber(doc);
  return number ? `АВР №${number}` : 'АВР';
}

export function avrPeriodLabel(doc: DriverDocument) {
  const meta = doc.metadata as Record<string, unknown> | undefined;
  const y = Number(meta?.periodYear);
  const m = Number(meta?.periodMonth);
  const months = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь',
  ];
  if (Number.isFinite(y) && Number.isFinite(m) && m >= 1 && m <= 12) {
    return `${months[m - 1]} ${y}`;
  }
  const date = meta?.document_date;
  if (date) {
    const match = String(date).match(/^(\d{4})-(\d{2})/);
    if (match) return `${months[Number(match[2]) - 1] || match[2]} ${match[1]}`;
  }
  return '';
}

export function statusColor(doc: DriverDocument) {
  switch (doc.waitingKey) {
    case 'COMPLETED':
    case 'SENT':
      return '#4caf50';
    case 'WAIT_YANDEX':
      return '#ff9800';
    case 'WAIT_DRIVER':
    case 'WAIT_SEND':
      return '#2196f3';
    case 'OVERDUE':
      return '#e64a19';
    case 'REJECTED':
    case 'CANCELLED':
      return '#c62828';
    default:
      return '#9e9e9e';
  }
}

export function isSignable(doc: DriverDocument) {
  return (
    doc.waitingKey === 'WAIT_DRIVER' ||
    doc.waitingKey === 'WAIT_SEND' ||
    doc.waitingKey === 'OVERDUE'
  );
}

function asMoney(value: unknown): number | null {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export function docAmount(doc: DriverDocument): number | null {
  const meta = (doc.metadata || {}) as Record<string, unknown>;
  let fromLines: number | null = null;
  if (Array.isArray(meta.lines)) {
    for (const line of meta.lines) {
      const amount = asMoney(
        line && typeof line === 'object' ? (line as Record<string, unknown>).amount : null,
      );
      if (amount == null) continue;
      fromLines = (fromLines ?? 0) + amount;
    }
  }
  return asMoney(meta.amount_total) ?? asMoney(meta.amountTotal) ?? fromLines ?? asMoney(doc.priceTotal);
}

export function formatListDt(value?: string) {
  if (!value) return '—';
  return new Date(value).toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
